<template>
  <div>
    <span> {{ $t('layouts.company') }} Copyright &copy; 2019 - {{ new Date().getFullYear() }} </span>
    <span>
      <a style="color: rgba(0, 0, 0, 0.65)" href="http://beian.miit.gov.cn" target="_blank">{{ $t('layouts.ICP') }}</a>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  computed: {},
  components: {}
};
</script>

<style scoped></style>
